import {
  Select,
  Stack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Document } from "types/Document";

type DocumentFilterProps = {
  documents: Document[];
  handleOnChangeDocument: (params: any) => any;
};

/**
 * Props for the DocumentFilter component.
 * 
 * @typedef {Object} DocumentFilterProps
 * @property {Document[]} documents - Array of document objects to be displayed in the select dropdown.
 * @property {(params: any) => any} handleOnChangeDocument - Callback function to handle the change event when a document is selected.
 */

/**
 * DocumentFilter component renders a dropdown select element populated with documents.
 * 
 * @component
 * @param {DocumentFilterProps} props - The props for the component.
 * @param {Document[]} props.documents - Array of document objects to be displayed in the select dropdown.
 * @param {(params: any) => any} props.handleOnChangeDocument - Callback function to handle the change event when a document is selected.
 * 
 * @returns {JSX.Element} The rendered DocumentFilter component.
 */

export default function DocumentFilter({
  documents,
  handleOnChangeDocument,
}: DocumentFilterProps) {

  return (
    <>
      <Select
        aria-label="Seleziona un documento"
        placeholder="Seleziona un documento"
        onChange={handleOnChangeDocument}
        defaultValue={0}
      >
        {documents?.map((document: Document, index) => {
          return (
            <option key={index} value={document?._id}>
              {document?.code} - {document?.title}
            </option>
          );
        })}
      </Select>
    </>);
}
